module.exports = "query GetFonts {\n  fonts {\n    ...FontFragment\n  }\n}\n"